module.exports = __webpack_public_path__ + "img/region-med-ctr.b1ca2041.png";